export enum EPurpose {
  OwnStay = 'OwnStay',
  Investment = 'Investment',
  None = 'None',
}
